module.exports = __webpack_public_path__ + "media/images/ep8-cindy-af67041be62a8de50e85f5b5e48219c8.png";